import { render, staticRenderFns } from "./mediaModel.vue?vue&type=template&id=33c1d2e0"
import script from "./mediaModel.vue?vue&type=script&lang=js"
export * from "./mediaModel.vue?vue&type=script&lang=js"
import style0 from "./mediaModel.vue?vue&type=style&index=0&id=33c1d2e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports